module.exports = __webpack_public_path__ + "static/future-glory-caea7a62869b062876c6421086f2d42a.png";